import { atom } from "jotai";

export const shouldShowStepIdsAtom = atom(false);

shouldShowStepIdsAtom.debugLabel = "shouldShowStepIdsAtom";
